import { Card, CardColumn, CardRow } from 'carbon-react/lib/components/card';
import Divider from 'carbon-react/lib/components/divider';
import Typography from 'carbon-react/lib/components/typography';
import GoBackButton from '../../components/GoBackButton';
import DeleteInstanceForm from './DeleteInstanceForm';

function DeleteInstance() {
  return (
    <div className="intacct-admin-inner-container">
      <GoBackButton />
      <Card>
        <CardRow pb={0}>
          <CardColumn align="left">
            <Typography variant="h1" mt={2}>
              Delete company instance
            </Typography>
          </CardColumn>
        </CardRow>
        <Divider type="horizontal" mt={2} mb={2} />
        <DeleteInstanceForm />
      </Card>
    </div>
  );
}

export default DeleteInstance;
